import React from 'react'

const InventoryManager = () => {
  return (
    <section className="project">
      <p>This is an inventory manager!</p>
      <iframe title="InventoryManager" src="https://inventory-manager-ttse.onrender.com/" />
    </section>
  )
}

export default InventoryManager;